/**
 * Typing Indicator
 *
 * Shows when agent is generating but no tokens have arrived yet.
 */

import type { CSSProperties } from 'react'

export function TypingIndicator() {
  return (
    <div
      style={styles.container}
      data-testid="typing-indicator"
      role="status"
      aria-label="Agent is typing"
    >
      <span style={styles.srOnly}>Agent is typing</span>
      <div
        style={styles.dot}
        className="animate-bounce"
      />
      <div
        style={{ ...styles.dot, animationDelay: '150ms' }}
        className="animate-bounce"
      />
      <div
        style={{ ...styles.dot, animationDelay: '300ms' }}
        className="animate-bounce"
      />
    </div>
  )
}

const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    gap: '4px',
  },
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: 'currentColor',
  },
}
